import { render } from "./_utm_report.vue?vue&type=template&id=3c2b710a&scoped=true"
import script from "./_utm_report.vue?vue&type=script&lang=js"
export * from "./_utm_report.vue?vue&type=script&lang=js"

import "./_utm_report.vue?vue&type=style&index=0&id=3c2b710a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2b710a"]])

export default __exports__